<template>
	<v-container>
		<v-row>
			<v-col
				class="d-flex justify-center align-center"
			>
				<v-icon
					color="primary"
					icon="$check"
				/>
			</v-col>
		</v-row>
		<v-row>
			<v-spacer />
			<v-col
				cols="5"
			>
				<p class="text-center">
					<translate>
						Thank you for your Tulip Assist insurance application!
					</translate>
					<br>
					<translate>
						Tulip Assist will let you know by e-mail within two working days whether your request can be processed or whether they need anything else. Once your application has been accepted, the insurance will take effect immediately and you will receive the policy schedule.
					</translate>
				</p>
			</v-col>
			<v-spacer />
		</v-row>
	</v-container>
</template>
